import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const videoChatStore = defineStore("videochat", () => {
  const room = ref(null);
  const IsCallEnded = ref(false);
  const MuteVideo = ref(false);
  const MuteAudio = ref(false);

  const setMuteAudio = (audio) => {
    const MuteAudio = audio;
  };

  const setMuteVideo = (video) => {
    MuteVideo.value = video;
  };

  const setIsCallEnded = (call) => {
    IsCallEnded.value = call;
  };

  const Addroom = (newRoom) => {
    room.value = newRoom;
  };

  const getRoom = computed(() => {
    return room.value;
  });

  return {
    room,
    Addroom,
    getRoom,
    setIsCallEnded,
    IsCallEnded,
    setMuteVideo,
      MuteVideo,
      MuteAudio,
      setMuteAudio
  };
});
